import { AiOutlineInfoCircle } from 'react-icons/ai';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const CustomerInfo = styled.div`
  width: 55%;
`;

export const PrimaryOfficeContactInfo = styled.div`
  width: 45%;
`;

export const TextInputWrapper = styled.div`
  display: flex;
  align-items: first baseline;
  justify-content: space-between;
  margin: 5px 20px;
  /* width: 90%; */
`;

export const TextInputLabel = styled.label`
  width: 45%;
`;

export const Required = styled.span`
  color: rgba(212, 63, 88, 1);
  &::before {
    content: '*';
  }
`;

export const InputContainer = styled.label`
  width: 55%;
  position: relative;
`;

export const DateInputContainer = styled.label`
  width: 75%;
  position: relative;
`;

export const Heading = styled.h4``;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const AccpetedTCContainer = styled.div`
  padding: 20px;
  text-align: center;
  margin-top: 50%;
`;

export const OrderAdditionalInfoEditContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
    flex-direction: row;
    gap: 50px;
  }
`;

export const AdditionalInfoContainer = styled.div`
  min-width: 33.3%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    & + & {
      padding: 2rem 0 0 0;
    }
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 1.05rem;
  color: rgba(0, 0, 0, 0.93);
  margin: 10px 0px;
`;

export const AdditionalInfoData = styled.div`
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  font-size: 1rem;
  line-height: 1.5rem;
`;

export const DateDisplayInput = styled.input`
  height: 40px;
  background-color: #f2f2f2;
  border: 1px solid #f2f2f2;
  border-radius: 6px;
  padding: 0 40px 0 12px;
  font-size: 16px;
  color: ${({ value }) => (value ? '#000' : '#8c8c8c')};
  outline: none;
  cursor: pointer;
  box-sizing: border-box;

  &:focus {
    border-color: #2684ff;
  }
`;

export const ClearButton = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 14px;
  color: #8c8c8c;

  &:hover {
    color: #000;
  }
`;

export const CalendarContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  z-index: 1000;
`;

export const TextCursor = styled.div`
  cursor: pointer;
`;

export const InfoIcon = styled(AiOutlineInfoCircle)`
  margin-left: 5px;
`;

export const CheckboxGroup = styled.div`
  margin-left: -10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

export const ShippingPreferencesSection = styled.section`
  margin-bottom: 1.5rem;

  h2 {
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  p {
    font-style: italic;
    font-size: 0.875rem;
    line-height: 1.3;
    color: #555;
  }
`;
